import axios from 'axios'
import { getToken, removeToken, getTokenExpires } from '@/libs/utils'
import { Toast } from 'vant'
import store from '@/store'
import router from '@/router'
import config from '@/config'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
// axios 重试次数和延迟时间
axios.defaults.retry = 3
axios.defaults.retryDelay = 1000
const service = axios.create({
	baseURL: baseUrl,
	timeout: 10000,
	headers: {
		Accept: 'application/vnd.dysaas.v1+json',
		'Content-Type': 'application/json'
	},
	validateStatus(status) {
		return status >= 200 && status < 500
	}
})

const tip = (msg) => {
	Toast({
		message: msg,
		duration: 1500,
		forbidClick: true
	})
}

// 判断token是否快过期
const isTokenExpired = () => {
	let current = Date.now()
	let diff = getTokenExpires() - current
	return diff < 10 * 60 * 1000
}

// 用新的axios请求刷新token
// const refreshToken = () => {
// 	return new Promise((resolve, reject) => {
// 		axios({
// 			url: `${baseUrl}agent/auth/refresh`,
// 			headers: {
// 				Accept: 'application/vnd.dysaas.v1+json',
// 				'Content-Type': 'application/json',
// 				Authorization: `Bearer ${getToken()}`,
// 				'Cache-Control': 'no-cache'
// 			},
// 			method: 'post'
// 		})
// 			.then((res) => {
// 				resolve(res.data)
// 			})
// 			.catch((err) => {
// 				reject(err)
// 			})
// 	})
// }

const toLogin = () => {
	router.replace({
		path: '/login'
	})
}

// request 拦截器
service.interceptors.request.use(
	(config) => {
		if (store.state.user.token) {
			config.headers['Authorization'] = `Bearer ${getToken()}`
		}
		config.headers['language'] = 'en-US' //传入语言参数
		if (config.method == 'post') {
			if (config.url.indexOf('?') > 0) {
				config.url = `${config.url}&_t=${Date.parse(new Date()) / 1000}&lang=en-US`
			} else {
				config.url = `${config.url}?_t=${Date.parse(new Date()) / 1000}&lang=en-US`
			}
		} else if (config.method == 'get') {
			config.params = {
				_t: Date.parse(new Date()) / 1000,
				lang: 'en-US',
				...config.params
			}
		} else if (config.method == 'delete') {
			if (config.url.indexOf('?') > 0) {
				config.url = `${config.url}&_t=${Date.parse(new Date()) / 1000}`
			} else {
				config.url = `${config.url}?_t=${Date.parse(new Date()) / 1000}`
			}
		} else if (config.method == 'patch') {
			config.params = {
				_t: Date.parse(new Date()) / 1000,
				lang: 'en-US',
				...config.params
			}
		}
		if (!isTokenExpired()) return config

		if (['login', 'register'].includes(router.history.current.name)) {
			return config
		}

		removeToken()
		toLogin()
		return config
	},
	(error) => {
		console.log('requets error', error)
		Promise.reject(error)
	}
)

// response 拦截器
service.interceptors.response.use(
	(response) => {
		let code = response.data.code
		if (code > 300 && code < 500) {
			if (code === 423 || code === 422) {
				tip(response.data.message)
				removeToken()
				toLogin()
				return Promise.reject(response.data)
			}
			tip(response.data.message)
			return Promise.reject(response.data)
		}

		return response.data
	},
	(error) => {
		let config = error.config
		// 如果不存在则直接返回错误

		if (!config || !config.retry) {
			return Promise.reject(error)
		}
		// 拦截 timeout
		if (error.message.includes('timeout')) {
			// 重新计数
			config.__retryCount = config.__retryCount || 0

			// 检查是否重新请求总数达到最大值
			if (config.__retryCount >= config.retry) {
				// Reject with the error
				tip('Connection timeout, Please check your network settings')
				return Promise.reject(error)
			}
			// 计数加1
			config.__retryCount += 1
			let backoff = new Promise(function (resolve) {
				setTimeout(function () {
					resolve()
				}, config.retryDelay || 1)
			})
			backoff
			return service(config)
		}
		const response = error.response
		console.log('error ===', response)
		if (response) {
			errorHandle(response.status, response.data.message, response.config)
			return Promise.reject(response.data)
		}
		return Promise.reject(error)
	}
)

const errorHandle = (status, other, config) => {
	// 状态码判断
	switch (status) {
		case 401:
			tip(other)

			if (config.url !== '/api/agent/auth/login') {
				removeToken()
				toLogin()
			}
			break
		case 403:
			tip('Login Expired')
			removeToken()
			toLogin()
			break
		case 404:
			tip('resource does not exist')
			break
		case 500:
			tip('System is busy')
			break
		case 501:
			tip('Service not implemented')
			break
		case 502:
			tip('Gateway error')
			break
		case 503:
			tip('Service not available')
			break
		case 504:
			tip('Gateway timeout')
			break
		case 505:
			tip('Http not supported')
			break
		default:
			if (other) {
				tip(other)
			}
	}
}

export default service
